module.exports = __webpack_public_path__ + "static/media/boldsign.5328134f.svg";